import useMediaQuery from '@mui/material/useMediaQuery';
import dynamic from 'next/dynamic';
import PostGrid from '../Grid/PostGrid';
import BlogSidebar from './BlogSidebar';
import ItinerariesList from './ItinerariesList';

const StickyBox = dynamic(() => import('react-sticky-box'), {
  ssr: false,
});

export default function BlogTab({ profile, itineraries }) {
  const author = profile.author.username;

  const renderLeftSidebar = useMediaQuery('(min-width: 768px)');

  return (
    <>
      <div className="container pt-1 pb-2 containerInvisibleOnMobile">
        <div className="row">
          {renderLeftSidebar ? (
            <div className="col-4">
              <StickyBox offsetTop={70} offsetBottom={10}>
                <BlogSidebar profile={profile} />
              </StickyBox>
            </div>
          ) : (
            <div className="col-12">
              <BlogSidebar profile={profile} />
            </div>
          )}
          <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
            {itineraries ? (
              <ItinerariesList initialItineraries={itineraries} />
            ) : (
              <PostGrid
                active="blog"
                query={{
                  author,
                  limit: 12,
                  useBlacklist: false,
                  orderby: 'createdAt',
                }}
                grid={{ lg: 11, md: 12, sm: 12, xs: 12 }}
                cardHeight={330}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
